import React, { useState, useEffect } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsMap from "highcharts/modules/map";
import { useVsiAppContext } from "../stores/VsiApp";
import styles from "../utils/themeStyles";

import { ChartArea } from "../styled/Stockchart.styled";
import ThemedChartLight from "./ThemedChartLight";
import ThemedChartDark from "./ThemedChartDark";
import { genericColors } from "../utils/chartUtils";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "./capacityModeling/CustomResourceCard";

HighchartsMap(Highcharts);

require("highcharts/indicators/indicators")(Highcharts);
require("highcharts/indicators/pivot-points")(Highcharts);
require("highcharts/indicators/macd")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/map")(Highcharts);

Highcharts.setOptions({
	lang: {
		thousandsSep: ','
	}
});

function ThreeDeeBubbleChart({ categories, data, series, title = "", height, includeLegend, config }) {
	const { theme, isTabletScreen } = useVsiAppContext();
	const basicTextStyle = {
		color: styles[theme].textColor,
		fontFamily: styles[theme].fontFamily,
	};

	const updateSeries = (series, data) => {
		if (series) return series;
		else if (data)
			return [
				{
					data,
				},
			];
		return [];
	};

	const [chartOptions, setChartOptions] = useState(() => {
		return {
			credits: {
				enabled: false,
			},
			colors: genericColors,
			title: {
				text: title,
				style: basicTextStyle,
			},
			mapNavigation: {
				enabled: true
			},
			xAxis: {
				gridLineWidth: 1,
				labels: {
				  style: basicTextStyle,
				},
				categories: categories || undefined,
			},
			yAxis: {
				...config.yAxis,
				title: {
					...config.yAxis.title,
					style: {
						...basicTextStyle,
						fontWeight: '600'
					}
				},
				labels: {
				  style: basicTextStyle,
				},
				startOnTick: false,
				endOnTick: false,
			},
			chart: {
				type: 'bubble',
				plotBorderWidth: 1,
				zoomType: 'xy',
				backgroundColor: "transparent",
				color: styles[theme].textColor,
				height: height ? height: 450,
			},
			legend: {
				itemStyle: basicTextStyle,
				align: "center",
				enabled: !includeLegend
			},
			tooltip: {
				// pointFormat: '{series.name}: <b>{point.y}</b>',
				backgroundColor: styles[theme].altBgColor,
				style: basicTextStyle
			},
			series: updateSeries(series, data)
		};
	});

	useEffect(() => {
		setChartOptions(() => {
			return {
				credits: {
					enabled: false,
				},
				title: {
					text: title,
					style: basicTextStyle,
				},
				chart: {
					...chartOptions.chart,
					backgroundColor: "transparent",
					color: styles[theme].textColor,
					height: height ? height: 450,
				},
				mapNavigation: {
					enabled: true
				},
				xAxis: {
					gridLineWidth: 1,
					categories: categories || undefined,
					labels: {
					  style: basicTextStyle,
					},
				},
				yAxis: {
					...config.yAxis,
					...chartOptions.yAxis,
					title: {
						...config.yAxis.title,
						style: {
							...basicTextStyle,
							fontWeight: '600'
						}
					},
				},
				legend: {
					itemStyle: basicTextStyle,
					align: "center",
					enabled: includeLegend ? true : false
				},
				labels: {
				  style: basicTextStyle,
				},
				tooltip: {
					// pointFormat: '{series.name}: <b>{point.y}</b>',
					backgroundColor: styles[theme].altBgColor,
					style: basicTextStyle
				},
				series: updateSeries(series, data)
			};
		});
		// eslint-disable-next-line
	}, [categories, series, data, theme, isTabletScreen]);

	return <ChartArea>
		{"light" ? (
			<ThemedChartLight options={chartOptions}/>
		): (
			<ThemedChartDark options={chartOptions}/>
		)}
	</ChartArea>
}

ThreeDeeBubbleChart.displayName = "3DBubbleChart"

export default withErrorBoundary(ThreeDeeBubbleChart, GeneralErrorBoundary);
